import React, { useState } from 'react';
import { getTier, STAT_LABELS } from './achievementUtils';
import MedalTooltip from './MedalTooltip';

interface MedalProps {
    rank: number;
    totalPlayers: number;
    stat: string;
    showLabel?: boolean;
    scale?: number;
}

const Medal: React.FC<MedalProps> = ({ rank, totalPlayers, stat, showLabel = true, scale }) => {
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const tier = getTier(rank);
    const statLabel = STAT_LABELS[stat];

    const sizeMultiplier = scale ?? tier.sizeMultiplier;
    const hexSize = Math.round(72 * sizeMultiplier);

    return (
        <div
            className={`medal medal--${tier.name}`}
            onMouseEnter={() => setTooltipVisible(true)}
            onMouseLeave={() => setTooltipVisible(false)}
            onFocus={() => setTooltipVisible(true)}
            onBlur={() => setTooltipVisible(false)}
            tabIndex={0}
            role="img"
            aria-label={`Rank ${rank} in ${statLabel?.full || stat}`}
        >
            <MedalTooltip
                rank={rank}
                totalPlayers={totalPlayers}
                stat={stat}
                visible={tooltipVisible}
            />

            <div
                className="medal__hex"
                style={{ width: hexSize, height: hexSize }}
            >
                <div className="medal__texture" />
                {tier.hasAccent && <div className="medal__accent" />}
                <span className="medal__rank">{rank}</span>
            </div>

            {showLabel && (
                <div className="medal__label">
                    {statLabel?.short || stat}
                </div>
            )}
        </div>
    );
};

export default Medal;
